import { Box } from '@mui/material';
import { notUndefiend, valueAsString } from 'helpers/conversions';
import React, { useRef } from 'react';
import { ICardProps, StatsData } from './Card';
import { Spinner, SpinnerContainer } from './Styles';
import { styles } from './ProductivityCardMobileApollo.styles';
import { ReactComponent as ArrowUp } from '../../assets/icons/ArrowUp.svg';

const ProductivityCardMobileApollo = (props: ICardProps) => {
  const { value, units, description, icons, stats, statsDescription, addedData, isPercentage } =
    props;
  const isNegative = React.useMemo(() => {
    if (!notUndefiend([stats])) {
      return false;
    }
    if (stats! < 0) {
      return true;
    }
    if (description === 'Average Availability' && value !== undefined && value >= 0.999) {
      return false;
    }
    return false;
  }, [description, stats, value]);
  const hasAddedData = !!addedData;
  const rightColumnRef = useRef(null);
  const [rightColumnWidth, setRightColumnWidth] = React.useState(0);
  React.useEffect(() => {
    if (notUndefiend([stats])) {
      if (rightColumnRef.current) {
        const { width } = rightColumnRef.current.getBoundingClientRect();
        setRightColumnWidth(width);
      }
    }
  }, [stats]);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      width="100%"
      height="100%"
      boxSizing="border-box"
      sx={styles.cardContent}>
      {notUndefiend([value]) ? (
        <>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            width="100%"
            height="100%"
            boxSizing="border-box"
            sx={styles.leftColumn}>
            <Box display="flex" flexDirection="column" height="70px" boxSizing="border-box">
              <Box display="flex" alignItems="flex-start">
                <Box sx={styles.icon}>{isNegative ? icons.negative : icons.positive}</Box>
                <Box sx={styles.value(value)} data-testid="productivity-value">
                  {valueAsString(value, isPercentage)}
                </Box>
                <Box sx={styles.units} data-testid="productivity-units">
                  {units}
                </Box>
              </Box>
              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={styles.leftColUpperRowDescriptionSubRow}>
                {description}
              </Box>
            </Box>
            <Box
              display="flex"
              alignItems="flex-end"
              height="30px"
              boxSizing="border-box"
              sx={styles.leftColBottomRow}
              data-testid="productivity-description">
              {notUndefiend([stats]) && StatsData(stats)} {statsDescription}
            </Box>
          </Box>
          {hasAddedData && (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              height="100%"
              boxSizing="border-box"
              sx={styles.rightColumn}
              ref={rightColumnRef}
              data-testid="right-column">
              <Box
                display="flex"
                flexDirection="column"
                boxSizing="border-box"
                data-testid="upper-row-right">
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="baseline"
                  width={rightColumnWidth}
                  data-testid="upper-value-row">
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    sx={styles.valueAndUnitWrapper}
                    data-testid="value-unit-wrapper">
                    <Box sx={styles.rightColumnRowValueSubRowItemValue} data-testid="added-value">
                      {addedData.upper.formatter
                        ? addedData.upper.formatter(addedData.upper.value)
                        : valueAsString(addedData.upper.value!)}
                    </Box>
                    <Box sx={styles.rightColumnRowValueSubRowItemUnits} data-testid="added-units">
                      {addedData.upper.unit}
                    </Box>
                  </Box>
                  <Box data-testid="upper-arrow-icon">
                    {addedData.upper.trend !== 0 && addedData.upper.trend !== undefined && (
                      <ArrowUp
                        width={14}
                        height={18}
                        style={{
                          transform: addedData.upper.trend < 0 ? 'rotate(180deg)' : '',
                        }}
                      />
                    )}
                  </Box>
                </Box>
                <Box
                  sx={styles.rightColumnRowDescriptionSubRow}
                  data-testid="added-stats-description">
                  {addedData.upper.description}
                </Box>
              </Box>
            </Box>
          )}
        </>
      ) : (
        <SpinnerContainer>{Spinner()}</SpinnerContainer>
      )}
    </Box>
  );
};
export default ProductivityCardMobileApollo;

